import React from "react";
import ColumnChart from "../../components/Charts/ColumnChart";

function ColumnChartCard() {
  const categories = ["2025-06", "2025-07", "2025-08"];
  const series = [
    { name: "Budget", data: [4500, 3000, 5000] },
    { name: "Income", data: [8000, 1000, 7000] },
    { name: "Expenses", data: [4000, 4000, 6000] },
  ];

  return (
    <div className="card portal-card flex-grow-1">
      <div className="card-body">
        <ColumnChart categories={categories} series={series} title="최근 3개월" />
      </div>
    </div>
  );
}

export default ColumnChartCard;